import { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { DraftOrderFormModalContainer } from "..";
import { useIntl } from "react-intl";
import { useAuth } from "src/app/utils/useAuth";
import { UserModel } from "src/app/types/UserModel";
import { UserTransport } from "src/app/transports/user";

const DraftOrderContainer = () => {
    const [userUnderManagement, setUserUnderManagement] = useState<Array<UserModel>>([]);
    const { currentUser } = useAuth();
    const [userSelected, setUserSelected] = useState<UserModel | null>();
    const { formatMessage } = useIntl();
    const handleClose = () => {
        setUserSelected(null);
    };

    useEffect(() => {
        (async () => {
            setUserUnderManagement(await UserTransport.usersUnderManagement());
        })();
    }, []);

    return (
        <div className="d-flex flex-column">
            <h2 className="mt-5">{formatMessage({ id: "dashboard.order.title" })}</h2>
            <div className="d-flex flex-column gap-2">
                <Col sm={10}>
                    <Button onClick={() => setUserSelected(currentUser)} className="">
                        {formatMessage({ id: "dashboard.button.draft" })}
                    </Button>
                </Col>
                {userUnderManagement && (
                    <>
                        {userUnderManagement?.map((user: UserModel, index) => (
                            <Col sm={10}>
                                <Button key={index} onClick={() => setUserSelected(user)}>
                                    {`${formatMessage({
                                        id: "dashboard.button.draft",
                                    })} ${formatMessage({ id: "common.field.of" })} ${
                                        user.firstName
                                    }`}
                                </Button>
                            </Col>
                        ))}
                    </>
                )}
            </div>

            {userSelected && (
                <DraftOrderFormModalContainer
                    handleClose={handleClose}
                    userSelected={userSelected}
                    isModalOpen={!!userSelected}
                />
            )}
        </div>
    );
};

export default DraftOrderContainer;
